import { render, staticRenderFns } from "./priceLastMileDetail.vue?vue&type=template&id=732139a8&scoped=true&"
import script from "./priceLastMileDetail.vue?vue&type=script&lang=js&"
export * from "./priceLastMileDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732139a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('732139a8')) {
      api.createRecord('732139a8', component.options)
    } else {
      api.reload('732139a8', component.options)
    }
    module.hot.accept("./priceLastMileDetail.vue?vue&type=template&id=732139a8&scoped=true&", function () {
      api.rerender('732139a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Price/priceLastMileDetail.vue"
export default component.exports